module.exports = __webpack_public_path__ + "static/media/브로슈어 다운로드용.003dad78.pdf";